import { render, staticRenderFns } from "./CajaTabla.vue?vue&type=template&id=d6ede1a0"
import script from "./CajaTabla.vue?vue&type=script&lang=js"
export * from "./CajaTabla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports